import * as Yup from 'yup'

const ratingValidator = Yup.object ({
  value: Yup
    .number ()
    .min (1, 'Escolha uma nota entre 1 e 5 estrelas'),

  comment: Yup.string ().when ('value', {
    is: (value) => value > 0 && value < 4,
    then: (schema) => schema.required ('Para avliações de 3 estrelas ou menos, é necessário escrever um comentário')
  })
})

export default ratingValidator
